import { useSelector } from 'react-redux';
import type { Chat } from '@trinity/chat';
import { createSelector } from 'reselect';
import type { RootState } from '@/store/store';

const selectAuthor = (user: RootState['user'], group: RootState['group']): Chat.Creator => {
  if (!user && !group) {
    return {
      identifier: null,
      profile: {
        email: '',
        firstName: '',
        lastName: '',
        name: '',
        photoUrl: null,
      },
      isFirstSession: false,
      group: { id: 0 },
    };
  }

  return {
    identifier: user.identifier,
    profile: {
      email: user.email,
      firstName: user.profile.firstName,
      lastName: user.profile.lastName,
      name: user.profile.name,
      photoUrl: user.profile.photoUrl,
    },
    isFirstSession: user.isFirstSession || false,
    group: { id: group.id },
  };
};

const userSelector = (state: RootState) => state.user;
const groupSelector = (state: RootState) => state.group;

const selector = createSelector([userSelector, groupSelector], (user, group) => {
  const author = selectAuthor(user, group);
  return author;
});

export const useBrandInsightsAuthor = () => {
  const author = useSelector(selector);
  return author;
};